import {
  ChangeDetectionStrategy,
  Component,
  ComponentRef,
  Injector,
  Input,
  ViewChild,
  ViewContainerRef,
  ɵcreateInjector as createInjector,
} from '@angular/core';
import { TrackingMapsRenderService } from '../tracking-maps-render.service';
import { ShipmentsGlobalMapComponent } from './shipments-global-map/shipments-global-map.component';
import { filter, take } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { IconNames } from '../../../common/constants';
import { ShipmentGlobalTrackingMapModel } from '../../../store/state/monitoring/shipment/models/shipment-list/shipment-global-tracking-map.model';

@Component({
  selector: 'lib-shipments-global-tracking-map',
  templateUrl: './shipments-global-tracking-map.component.html',
  styleUrls: ['./shipments-global-tracking-map.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShipmentsGlobalTrackingMapComponent {
  @Input() set mapData(mapData: ShipmentGlobalTrackingMapModel[]) {
    if (mapData) {
      if (this.componentRef) {
        this.componentRef.instance.resetState = !this._mapData.length;
        this.componentRef.instance.mapData = mapData;
      } else {
        this.scriptAppendSubscription(mapData);
      }

      if (!this.isMapExpendable) {
        this.isOpened$.next(false);
      }

      this._mapData = mapData;
    }
  }
  @Input() set completelyLoaded(loaded: boolean) {
    this.completelyLoaded$.next(loaded);
  }
  @Input() firstChunkLoaded = false;
  @Input() isMapThresholdReached = false;
  @Input() mapThreshold: number | null = null;
  @Input() totalShipments: number | null = null;

  get isMapExpendable(): boolean {
    return this.totalShipments > 0;
  }

  get tooltipMessage(): string | null {
    if (!this.isMapThresholdReached) {
      return 'monitoring.shipmentsTrackingMap.tooltipThresholdMessage';
    }

    if (!this.isMapExpendable) {
      return 'common.list.noData';
    }

    return null;
  }

  @ViewChild('mapContainer', { read: ViewContainerRef, static: false })
  mapContainerRef: ViewContainerRef;

  iconNames = IconNames;
  isOpened$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  completelyLoaded$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  private _mapData: ShipmentGlobalTrackingMapModel[] = [];
  private componentRef: ComponentRef<ShipmentsGlobalMapComponent> | null = null;

  constructor(private trackingMapsRenderService: TrackingMapsRenderService, private injector: Injector) {}

  toggleMap(): void {
    if (!this.isMapExpendable || !this.firstChunkLoaded) {
      return;
    }

    this.isOpened$.next(!this.isOpened$.getValue());
  }

  private scriptAppendSubscription(mapData: ShipmentGlobalTrackingMapModel[]): void {
    this.trackingMapsRenderService.isGoogleMapApiScriptAppended$.pipe(filter(Boolean), take(1)).subscribe(async () => {
      if (this.mapContainerRef) {
        const moduleRef = await import('./shipments-global-map/shipments-global-map.module');

        const injector = createInjector(moduleRef.ShipmentsGlobalMapModule, this.injector);
        const module = injector.get(moduleRef.ShipmentsGlobalMapModule);

        this.componentRef = module.render(this.mapContainerRef);
        this.componentRef.instance.mapData = mapData;
      }
    });
  }
}
